export class PersonalInfo {
    phoneNumber: string;
    email: string;
    providerId: number;
    imageIdentifier?: string;
    resetImage?: boolean;

    constructor(obj: PersonalInfo | any) {
        Object.assign(this, obj);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/settings/shared/models/personal-info.model.ts